"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../core/input-on-blur"));
var _selectCode = _interopRequireDefault(require("../../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // NOTE This module is used in new-application and application-change
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Slalom Site*");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Organising Club*");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "2nd Organising Club if applicable");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Number of days spanned by Competition*");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "How many weeks could you move by?");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Application Notes");
class CoreApplication extends _react.Component {
  render() {
    const application = this.props.application;
    return /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4
      }, {
        sm: 8
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "Sites",
      value: application.siteID,
      onChange: this.props.setSelected.bind(this, 'siteID'),
      name: "siteID",
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "OrganisingClubs",
      value: application.clubID1,
      onChange: this.props.setSelected.bind(this, 'clubID1'),
      name: "clubID1",
      clearable: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "OrganisingClubs",
      value: application.clubID2,
      onChange: this.props.setSelected.bind(this, 'clubID2'),
      name: "clubID2",
      clearable: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Integer",
      name: "numberOfDays",
      value: application.numberOfDays,
      onChange: this.props.setValue,
      maxLength: 1,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Integer",
      name: "canMoveByWeeks",
      value: application.canMoveByWeeks,
      onChange: this.props.setValue,
      maxLength: 2
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "TextArea",
      name: "notes",
      value: application.notes,
      onChange: this.props.setValue,
      maxLength: 800,
      placeholder: "This is not the calendar info, but rather anything that might help when agreeing the calendar, eg Date restrictions on moving"
    }))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CoreApplication, "partialQueries", {
  Application: {
    id: true,
    calendarID: true,
    calendarDateID: true,
    clubID1: true,
    clubID2: true,
    numberOfDays: true,
    siteID: true,
    notes: true,
    canMoveByWeeks: true
  }
});
var _default = exports.default = CoreApplication;